<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="row mb-3">
        <div class="col-md-8">
          <h5 class="font-weight-bold mb-0">Gestante(s)</h5>
          <small class="text-muted"
            >Total de registros {{ item.gestantes.length }}</small
          >
        </div>
        <div class="col-md-4 text-right">
          <button
            class="btn btn-sm btn-primary"
            @click="$bvModal.show('cadastrar-gestante')"
          >
            <i class="fas fa-plus-square" />
            {{ $t("Cadastrar") }}
          </button>
        </div>
      </div>
      <div v-if="item.gestantes.length == 0">
        <h4 class="text-secondary">
          <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
          A familia não possui gestantes.
        </h4>
      </div>
      <div v-for="usuario in item.gestantes" :key="usuario.id">
        <div class="p-0 col-12 mb-3">
          <table class="table table-bordered">
            <tbody>
              <tr class="col-12">
                <td colspan="2">
                  <router-link :to="'/dashboard/usuario/edit/' + usuario.id">
                    <strong>
                      {{ usuario.usuario_id.nome_completo }}
                    </strong>
                  </router-link>
                  <br />
                  Idade: {{ usuario.usuario_id.idade }} ano(s)<br />
                </td>
              </tr>
              <tr v-if="usuario.meses_gestacao">
                <th>Quantos meses de gestação?</th>
                <td>{{ usuario.meses_gestacao }} mes(es)</td>
              </tr>  
              <tr v-if="usuario.semanas_gestacao">
                <th>Quantas semanas de gestação?</th>
                <td>{{ usuario.semanas_gestacao }} semana(s)</td>
              </tr>
              <tr>
                <th>Já iniciou Pré-Natal</th>
                <td>{{ usuario.inicio_pre_natal == 1 ? "Sim" : "Não" }}</td>
              </tr>
              <tr>
                <th>Data do Registro</th>
                <td>{{ usuario.data_anotacao }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Observação</b>
                  <p>{{ usuario.observacao }}</p>
                </td>
              </tr>
              <tr v-if="usuario.user">
                <td colspan="2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <small class="text-muted d-block"
                      >Técnico: {{ usuario.user.name }} <br />Unidade:
                      {{ usuario.user.tecnico.unidade.nome }}</small
                    >
                    <b-button
                      title="Desativar registro"
                      @click="desativarRegistro(usuario.id)"
                      :class="'px-2 mb-0 btn-excluir-' + usuario.id"
                      size="xs"
                      type="button"
                      v-b-tooltip.hover
                      v-if="usuario.user_id == $store.state.user.id"
                      variant="danger"
                      data-style="zoom-in"
                    >
                      <i class="fas fa-fw fa-trash" />
                    </b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Cadastrar :item="item" />
  </div>
</template>
<script >
import Cadastrar from "./ModalCadastrarGestante";

export default {
  props: ["item"],
  components: { Cadastrar },
  methods: {
    desativarRegistro(id) {
      let ladda = Ladda.create(document.querySelector(".btn-excluir-" + id));
      ladda.start();
      swal
        .fire({
          title: this.$t("Are you sure?"),
          text: "O registro será desativado e não aparecerá na listagem de dados",
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: this.$t("Delete"),
          icon: "warning",
        })
        .then((value) => {
          if (value.isConfirmed) {
            axios
              .put("api/dashboard/familias/gestanteupdate/" + id, { status: 2 })
              .then((response) => {
                this.$snack.success({
                  button: false,
                  text: "Registro desativado com sucesso!",
                });

                this.item.gestantes = response.data;
              })
              .catch(() => {
                ladda.stop();
              });
          }
        });
    },
  },
};
</script>

